import { ref, watch } from 'vue';
import AceleresLinkPreviewsAPI from 'dashboard/api/aceleres/linkPreviews';

// Aceleres -- titulo e descricao da pagina de um endereco citado na conversa.
// O backend le as meta tags (e o oEmbed, no caso do YouTube) e guarda o
// resultado em cache; esta tabela evita repetir o pedido entre as bolhas do
// chat dentro da mesma sessao. A promessa fica guardada, e nao so o resultado,
// para que duas bolhas com o mesmo link facam um unico pedido.
const previews = new Map();

const fetchPreview = url => {
  if (!previews.has(url)) {
    previews.set(
      url,
      AceleresLinkPreviewsAPI.show(url)
        .then(({ data }) => data || {})
        .catch(() => ({}))
    );
  }

  return previews.get(url);
};

export function useLinkPreview(url) {
  const preview = ref(null);

  watch(
    url,
    value => {
      preview.value = null;
      if (!value) return;

      fetchPreview(value).then(data => {
        // So vale a previa que tem texto: sem titulo nem descricao o cartao
        // repetiria o endereco que ja esta na mensagem.
        if (data?.title || data?.description) preview.value = data;
      });
    },
    { immediate: true }
  );

  return { preview };
}
